import SpinToWinConstant from '../constant/SpinToWinConstant';

export interface SpinToWinPayload {
  targetPrice: number;
  timerSeconds: number;
  announcement: string;
}

export const setSpinToWin = (value: SpinToWinPayload) => ({
  type: SpinToWinConstant.SET_SPIN_TO_WIN,
  payload: value,
});

export const resetSpinToWin = () => ({
  type: SpinToWinConstant.RESET_SPIN_TO_WIN,
});

export const tickTimer = () => ({
  type: SpinToWinConstant.TICK_TIMER,
});

export const setSpinResult = (prize: number) => ({
  type: SpinToWinConstant.SET_SPIN_RESULT,
  payload: prize,
});

export const startSpinToWin = () => ({
  type: SpinToWinConstant.START_SPIN_TO_WIN,
});

export const nextStep = () => ({
  type: SpinToWinConstant.NEXT_STEP,
});

export const setUserDetails = (details: { firstName: string; lastName: string; storeNumber: string }) => ({
  type: SpinToWinConstant.SET_USER_DETAILS,
  payload: details,
});

// Stops the countdown — dispatched when the design is submitted so the clock
// can't run out during the save or while the confirmation is up.
export const pauseTimer = () => ({
  type: SpinToWinConstant.PAUSE_TIMER,
});

export const setChallengeEnd = (isoTime: string) => ({
  type: SpinToWinConstant.SET_CHALLENGE_END,
  payload: isoTime,
});
